import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const USER_ANALYTICS_STORAGE_KEY = 'ultrahuman_user_analytics';

// Signal keys for pre-existing-user detection: docs/user-analytics.md#pre-existing-users
// Cart localStorage keys are lowercase, hence the toLowerCase().
export const SHOPIFY_STORES = Object.values(ShopifyStore).map((store) =>
  store.toLowerCase(),
) as Lowercase<ShopifyStore>[];

export const CART_KEY_PREFIX = 'cart_';

export const COOKIE_CONSENT_KEY = 'COOKIE_CONSENT';

export const BLOOD_VISION_KEYS = [
  'bloodVisionIndiaCart',
  'bloodVisionIndiaPincode',
  'bloodVisionIndiaCheckoutData',
] as const;

// Event names below are read by GTM/Vercel Analytics — external identifiers, don't rename.
// "New" = no pre-existing signals found, "returning" = at least one.

export const USER_ANALYTICS_EVENTS = {
  PAGE_VISIT: 'user_analytics_page_visit',
  NEW_USER_DETECTED: 'user_analytics_new_user',
  RETURNING_USER_DETECTED: 'user_analytics_returning_user',
} as const;

export const USER_ANALYTICS_GTM_EVENTS = {
  PAGE_VISIT: 'userAnalyticsPageVisit',
  NEW_USER_DETECTED: 'userAnalyticsNewUser',
  RETURNING_USER_DETECTED: 'userAnalyticsReturningUser',
} as const;
